import styled from "styled-components";

export const StyledWarningIcon = styled.div`
    position: absolute;
    top: 20px;
    left: 24px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.dangerTypographyColor};
    border: 2px solid ${({ theme }) => theme.dangerTypographyColor};
`;
